import { JsonAny } from "../../Types";
import parseISO from "date-fns/parseISO";

export interface VideoComment {
    id: number;
    userName?: string;
    videoId: number;
    userId: number;
    text: string;
    commentTimeMillis: number;
    created: Date;
    isPrivate?: boolean;
    userImageUrl?: string;
}

export interface VideoCommentChangeSet {
    id?: number;
    videoId: number;
    userId: number;
    text: string;
    commentTimeMillis: number;
    isPrivate: boolean;
}

export function parseVideoComment(json: JsonAny): VideoComment {
    return {
        ...json,
        created: parseISO(json.created),
    };
}
